module.exports = __webpack_public_path__ + "media/images/emblems/Kaufdorf-coat_of_arms-e2ca655738341eccf344db95dffc5d7f.svg";